function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return "";
}

function splitArray(data, lens = 7) {
  if (Object.prototype.toString.call(data) == "[object Array]") {
    let res = [];
    for (let i = 0; i < data.length; ) {
      res.push(res.slice(i, (i += lens)));
    }
    return res;
  } else {
    const arr = Object.keys(data);
    const ceil = Math.ceil(arr.length / lens);
    let res = [];
    for (let i = 0; i < ceil; i++) {
      const item = {};
      for (let k = 0; k < lens; k++) {
        const _key = arr[i * lens + k];
        if (_key && data[_key]) {
          item[_key] = data[_key];
        }
      }
      res.push(item);
    }
    return res;
  }
}

/**
 * 保留n位小数
 * @param {*} value 血糖值
 */
function formatNumberValue(value, num = 1) {
  if (!value) {
    return value;
  }
  return parseFloat(Number(value).toFixed(num));
}

/**
 * 检测系统 
 * @returns 
 */
function checkPlatform() {
  if (/android/i.test(navigator.userAgent)) {
    return "android";
  } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return "ios";
  }
  return "Unknown";
}

/**
 * 将日期转为时间戳
 * @returns 
 */
function getTimestamp(data) {
  var newTime = data.replace(/-/g, '/');
  var temp = new Date(newTime);
  var timestamp = temp.getTime();
  return timestamp;
}

/**
 * 返回 UTC 相对于当前时区的相差分钟数
 * @returns 
 */
function getTimeZone() {
  var temp = new Date();
  var timeZone = temp.getTimezoneOffset();

  if(timeZone != 0) {
    timeZone = timeZone * -1;
  }

  return timeZone;
}

/**
 * 检测Safari浏览器
 * @returns 
 */
function checkSafari() {

  var ua = navigator.userAgent.toLowerCase();

  if((/safari/.test(ua) && !/chrome/.test(ua))) {
    return true;
  }
  return false
}

/**
 * 检测微信浏览器
 * @returns
 */
function checkWechat() {

  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // 在微信中打开
    return true;
  }

  return false;
}

function getBuildNumber() {

  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/accuralink/i) != "accuralink" || ua.match(/qingtang/i) != "qingtang") {
    // 非清塘内嵌浏览器
    return 0;
  }

  var beginIndex = ua.indexOf("[accuralink");
  var mark = ua.substring(beginIndex + 1, ua.length - 1);
  var list = mark.split(",");

  // document.getElementById("pdfExport").innerHTML = list[3];

  return parseInt(list[3]);
}

export { getQueryString, splitArray, formatNumberValue, checkPlatform, getTimestamp, getTimeZone, checkWechat, getBuildNumber, checkSafari };
